import React from "react";
import "./StagingBanner.css";
import { getEnvironment } from "./Utils";

function StagingBanner() {
  const [isStaging,setIsStaging] = React.useState<boolean>(false);
  React.useEffect(() => {
    setIsStaging(getEnvironment() === 'staging');
  },[]);
  return (<>
      {isStaging && (
        <div className="is-staging-banner">
          <b>STAGING</b>
        </div>
      )}
      </>
  );
}

export default StagingBanner;
